<template>
  <div class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="img/logo-mfu-banner.png"  height="35" alt="CoreUI Logo">
        <!--<img class="navbar-brand-minimized" src="img/logo-mfu-banner.png" width="30" height="30" alt="CoreUI Logo">-->
      </b-link>
      <SidebarToggler class="d-md-down-none" display="lg" :defaultOpen=true />
      <!--<b-navbar-nav class="d-md-down-none">-->
        <!--<b-nav-item class="px-3" to="/dashboard">Dashboard</b-nav-item>-->
        <!--<b-nav-item class="px-3" to="/users" exact>Users</b-nav-item>-->
        <!--<b-nav-item class="px-3">Settings</b-nav-item>-->
      <!--</b-navbar-nav>-->
      <b-navbar-nav class="ml-auto">
        <!--<b-nav-item class="d-md-down-none">-->
          <!--<i class="icon-bell"></i>-->
          <!--<b-badge pill variant="danger">5</b-badge>-->
        <!--</b-nav-item>-->
        <!--<b-nav-item class="d-md-down-none">-->
          <!--<i class="icon-list"></i>-->
        <!--</b-nav-item>-->
        <!--<b-nav-item class="d-md-down-none">-->
          <!--<i class="icon-location-pin"></i>-->
        <!--</b-nav-item>-->
        <!--<DefaultHeaderDropdownAccnt/>-->
      </b-navbar-nav>
      <!--<AsideToggler class="d-none d-lg-block" />-->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <!--<div>-->
          <!--<Countdown end="01 20 2020"></Countdown>-->
        <!--</div>-->
        <SidebarNav class="bg-style1" :navItems="nav" ></SidebarNav>
        <SidebarFooter/>
<!--        <SidebarMinimizer/>-->
      </AppSidebar>
      <main class="main">
        <!--<Breadcrumb :list="list"/>-->
        <div style="height: 30px"></div>

        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <TheFooter>
      <!--footer-->
      <div>
        <a href="https://mis.mfu.ac.th">MIS</a>
        <span class="ml-1">&copy; 2019  Center Information Technology Service.</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1">Powered by</span>
        <a href="https://mis.mfu.ac.th">MIS</a>
      </div>
    </TheFooter>
  </div>
</template>

<script>
  import Countdown from 'vuejs-countdown'
  import store from '@/store/store'
import nav from '@/_nav'
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, AsideToggler, Footer as TheFooter, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeaderDropdownAccnt from './DefaultHeaderDropdownAccnt'
  import Service from "../service/api";

export default {
  name: 'DefaultContainer',
  components: {
    Countdown,
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Breadcrumb,
    DefaultAside,
    DefaultHeaderDropdownAccnt,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer
  },
  data () {
    return {
      nav:this.onNav(),
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }

  },

  methods: {
    onNav(){
      // switch ('3'){
        switch (this.$store.state.user.vtype){
        case "0":
          return [
            {
              title: true,
              name: 'STUDENT',
              class: '',
              wrapper: {
                element: '',
                attributes: {}
              }
            },
            {
              name: 'Create Withdraw',
              url: '/withdrow/create',
              icon: 'icon-drop'
            },
            {
              name: 'Withdraw Result',
              url: '/withdrow/result',
              icon: 'icon-drop'
            },
            {
              name: 'Withdraw History',
              url: '/withdrow/history',
              icon: 'icon-drop'
            },
            {
              name: 'Logout',
              url: '/logout',
              icon: 'icon-logout'
            }
            ];
        case "1":
         return [
           {
             title: true,
             name: 'INSTRUCTOR',
             class: '',
             wrapper: {
               element: '',
               attributes: {}
             }
           },
           {
              name: "Student's Course Withdraw ",
              url: '/instructors/withdraw',
              icon: 'icon-people'
            },
           {
             name: "Course History ",
             url: '/instructors/history',
             icon: 'icon-notebook'
           },
           {
             name: 'History',
             url: '/instructor',
             icon: 'icon-layers',
             children: [
               {
                 name: 'Approved',
                 url: '/instructor/approved',
                 icon: 'icon-check'
               },
               {
                 name: 'Disapproved',
                 url: '/instructor/disapproved',
                 icon: 'icon-ban'
               },
               {
                 name: 'Wait for Approve',
                 url: '/instructor/waitapproved',
                 icon: 'icon-speech'
               }
             ]
           },
           {
              title: true,
              name: 'ADVISOR',
              class: '',
              wrapper: {
                element: '',
                attributes: {}
              }
            },

           {
             name: "Student's Course Withdraw ",
             url: '/advisor/withdraw',
             icon: 'icon-people'
           },
           {
              name: 'History',
              url: '/advisor/history',
              icon: 'icon-layers',
              children: [
                {
                  name: 'Approved',
                  url: '/advisor/approved',
                  icon: 'icon-check'
                },
                {
                  name: 'Disapproved',
                  url: '/advisor/disapproved',
                  icon: 'icon-ban'
                },
                {
                  name: 'Wait for Approve',
                  url: '/advisor/waitapproved',
                  icon: 'icon-speech'
                }
              ]
           },
           {
             name: 'Logout',
             url: '/logout',
             icon: 'icon-logout'
           }
           ];
        case '2':
          return [
            {
              title: true,
              name: 'DEAN',
              class: '',
              wrapper: {
                element: '',
                attributes: {}
              }
            },
            {
              name: "Student's Course Withdraw ",
              url: '/dean/withdraw',
              icon: 'icon-people'
            },
            {
              name: 'History',
              url: '/dean',
              icon: 'icon-layers',
              children: [
                {
                  name: 'Approved',
                  url: '/dean/approved',
                  icon: 'icon-check'
                },
                {
                  name: 'Disapproved',
                  url: '/dean/disapproved',
                  icon: 'icon-ban'
                },
                {
                  name: 'Wait for Approve',
                  url: '/dean/waitapproved',
                  icon: 'icon-speech'
                }
              ]
            },
            {
              name: 'Logout',
              url: '/logout',
              icon: 'icon-logout'
            }
          ];
        case '3':
          return [
            {
              title: true,
              name: 'STAFF',
              class: '',
              wrapper: {
                element: '',
                attributes: {}
              }
            },
            {
              name: 'Student Withdraw',
              url: '/dean',
              icon: 'icon-layers',
            },
            {
              name: 'Reports',
              url: '/dean/withdraw',
              icon: 'icon-docs'
            },
            {
              name: 'Settings',
              url: '/staff',
              icon: 'icon-settings',
              children: [
                {
                  name: 'Calendar',
                  url: '/staff/calendar',
                  icon: 'icon-calendar'
                },
                {
                  name: 'Permisstion',
                  url: '/staff/permisstion',
                  icon: 'icon-user-following'
                },
                {
                  name: 'Login',
                  url: '/staff/login',
                  icon: 'icon-docs'
                },
                // {
                //   name: 'Announcement',
                //   url: '/staff/announcenment',
                //   icon: 'icon-bell'
                // }
              ]
            },
            {
              name: 'Logout',
              url: '/logout',
              icon: 'icon-logout'
            }
          ];
        case '4':
          return [
            {
              title: true,
              name: 'INSTRUCTOR',
              class: '',
              wrapper: {
                element: '',
                attributes: {}
              }
            },
            {
              name: "Student's Course Withdraw ",
              url: '/instructors/withdraw',
              icon: 'icon-people'
            },

            {
              name: "Course History ",
              url: '/instructors/history',
              icon: 'icon-notebook'
            },
            {
              name: 'History',
              url: '/instructor',
              icon: 'icon-layers',
              children: [
                {
                  name: 'Approved',
                  url: '/instructor/approved',
                  icon: 'icon-check'
                },
                {
                  name: 'Disapproved',
                  url: '/instructor/disapproved',
                  icon: 'icon-ban'
                },
                {
                  name: 'Wait for Approve',
                  url: '/instructor/waitapproved',
                  icon: 'icon-speech'
                }
              ]
            },

            {
              title: true,
              name: 'ADVISOR',
              class: '',
              wrapper: {
                element: '',
                attributes: {}
              }
            },
            {
              name: "Student's Course Withdraw ",
              url: '/advisor/withdraw',
              icon: 'icon-people'
            },
            {
              name: 'History',
              url: '/advisor/history',
              icon: 'icon-layers',
              children: [
                {
                  name: 'Approved',
                  url: '/advisor/approved',
                  icon: 'icon-check'
                },
                {
                  name: 'Disapproved',
                  url: '/advisor/disapproved',
                  icon: 'icon-ban'
                },
                {
                  name: 'Wait for Approve',
                  url: '/advisor/waitapproved',
                  icon: 'icon-speech'
                }
              ]
            },

            {
              title: true,
              name: 'DEAN',
              class: '',
              wrapper: {
                element: '',
                attributes: {}
              }
            },
            {
              name: "Student's Course Withdraw ",
              url: '/dean/withdraw',
              icon: 'icon-people'
            },
            {
              name: 'History',
              url: '/dean',
              icon: 'icon-layers',
              children: [
                {
                  name: 'Approved',
                  url: '/dean/approved',
                  icon: 'icon-check'
                },
                {
                  name: 'Disapproved',
                  url: '/dean/disapproved',
                  icon: 'icon-ban'
                },
                {
                  name: 'Wait for Approve',
                  url: '/dean/waitapproved',
                  icon: 'icon-speech'
                }
              ]
            },
            {
              name: 'Logout',
              url: '/logout',
              icon: 'icon-logout'
            }
          ];

      }
    },

    onReload(){

      this.$store.dispatch("setToken", localStorage.getItem('token'));
      this.$store.dispatch("setUser", JSON.parse(localStorage.getItem('user')));
      this.$store.dispatch("setUsername", localStorage.getItem('username'));

      Service.onSetToken();
    }

  },

  mounted() {
  },
  created () {
    this.onReload();
  },
}
</script>
<style>

.bg-style1{
  background: linear-gradient(30deg,#FEC260 0%,#8c1515 60%);
}
</style>
